import { useEffect } from "react";

import { adsConfig } from "@/config/ads.config";
import { useCookieConsent } from "@/hooks/useCookieConsent";
import type { AdBannerProps } from "@/types/ads";

export function AdBanner({ slot, label = "Advertisement" }: AdBannerProps) {
  const { accepted } = useCookieConsent();
  const slotId = adsConfig.slots[slot];

  useEffect(() => {
    if (!adsConfig.enabled || !adsConfig.client || !slotId || !accepted) return;

    try {
      const win = window as typeof window & { adsbygoogle?: unknown[] };
      win.adsbygoogle = win.adsbygoogle || [];
      win.adsbygoogle.push({});
    } catch {
      // Ad blockers or script timing can prevent AdSense from hydrating; the slot remains a graceful no-op.
    }
  }, [accepted, slotId]);

  if (!adsConfig.enabled || !adsConfig.client || !slotId || !accepted) {
    return null;
  }

  return (
    <div className="mx-auto my-8 w-full max-w-6xl border-y border-neutral-200 py-3 text-center dark:border-neutral-800">
      <p className="mb-2 text-[11px] uppercase tracking-[0.12em] text-neutral-500">{label}</p>
      <ins
        className="adsbygoogle block min-h-24"
        data-ad-client={adsConfig.client}
        data-ad-slot={slotId}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
}
